export default __webpack_public_path__ + "static/image7-52e355c686edeb409aec875511bd2403.jpg";